module.exports = __webpack_public_path__ + "img/nda-restricted-holding.68b9aad4.webp";